export const createGongChapterUrl = (
	embedUrl: string,
	startTimeInSeconds: number,
	endTimeInSeconds?: number | null,
): string => {
	try {
		const chapterUrl = new URL(embedUrl);
		chapterUrl.searchParams.set('from', String(startTimeInSeconds));

		if (endTimeInSeconds !== null && endTimeInSeconds !== undefined) {
			chapterUrl.searchParams.set('to', String(endTimeInSeconds));
		}

		return chapterUrl.toString();
	} catch {
		return embedUrl;
	}
};
